<div class="page-container">
  <div class="flex items-center justify-between">
    <h1 class="main-heading">Car allocation</h1>
    <app-navpath />
  </div>
  <ul class="tabs-container">
    <li
      (click)="selectedTab = 'single'"
      [ngClass]="
        selectedTab == 'single' ? 'tab-item_selected' : 'tab-item'
      "
    >
      Single allocation
    </li>
    <li
      (click)="selectedTab = 'all'"
      [ngClass]="
        selectedTab == 'all' ? 'tab-item_selected' : 'tab-item'
      "
    >
      Allocate all
    </li>
  </ul>

  <!-- Single Allocation -->
  <section
    class="content-container__tabs"
    [hidden]="!(selectedTab == 'single')"
  >
    <div class="content-container">
      <h2 class="sub-heading w-full border-b">
        Search available vehicles
      </h2>
      <app-data-form
        [dataFields]="searchVehicles"
        [dataName]="'searchVehicles'"
        (updateFields_child)="updateFields($event)"
      />
      <app-data-table
        class="mt-4 block"
        [tableHeaders]="tableSingleAllocation__headers"
        [tableEntries]="tableSingleAllocation__entries"
        (open)="openEntry($event)"
        [pageSize]="10"
        *ngIf="tableSingleAllocation__entries.length > 0"
      ></app-data-table>
      <p
        class="mt-4 block"
        *ngIf="tableSingleAllocation__entries.length == 0"
      >
        No Entries!
      </p>
    </div>

    <div class="content-container">
      <h2 class="sub-heading w-full border-b">Details of vehicle</h2>
      <app-data-form
        [dataFields]="detailsVehicle"
        [dataName]="'detailsVehicle'"
        (clickSearch)="search($event)"
      />
    </div>

    <div class="content-container">
      <h2 class="sub-heading w-full border-b">Details of contract</h2>
      <app-data-form
        [dataFields]="detailsContract"
        [dataName]="'detailsContract'"
        (clickSearch)="search($event)"
        (updateFields_child)="updateFields($event)"
      />
    </div>

    <div class="mt-4 flex w-fit gap-1">
      <button
        class="shorter-btn misc-btn"
        (click)="singleAllocation()"
      >
        <fa-icon [icon]="faPencil" class="mr-1" />Allocate
      </button>
      <button
        class="shorter-btn misc-btn"
        (click)="dropAllocation()"
        [disabled]="!isDropAllowed"
      >
        <fa-icon [icon]="faTrash" class="mr-1" />Drop allocation
      </button>
      <button class="shorter-btn misc-btn" (click)="clearDataForms()">
        <fa-icon [icon]="faBroom" class="mr-1" />Clear
      </button>
    </div>
  </section>

  <!-- Allocate All -->
  <section
    class="content-container__tabs"
    [hidden]="!(selectedTab == 'all')"
  >
    <div class="mt-4 flex gap-1">
      <button
        class="regular-btn misc-btn"
        (click)="allocateAll()"
      >
        <fa-icon [icon]="faPencil" class="mr-1" />Allocate all
      </button>

      <!-- <div *ngIf="isAllocationConfirmed" class="flex gap-1">
        <button class="shorter-btn misc-btn">
          <fa-icon [icon]="faSave" class="mr-1" />Allocated All
        </button>
        <button class="shorter-btn misc-btn">
          <fa-icon [icon]="faSave" class="mr-1" />Save Allocated
        </button>
        <button class="shorter-btn misc-btn">
          <fa-icon [icon]="faPrint" class="mr-1" />Print Allocated
          List
        </button>
        <button class="shorter-btn misc-btn">
          <fa-icon [icon]="faPrint" class="mr-1" />Print Not Allocated
          List
        </button>
      </div> -->
    </div>

    <app-data-table
      *ngIf="!isAllocationConfirmed"
      class="mt-4 block"
      [tableHeaders]="tableAllAllocation__headers"
      [tableEntries]="tableAllAllocation__entries"
      [pageSize]="50"
    ></app-data-table>

    <div *ngIf="isAllocationConfirmed" class="mt-4">
      <h2 class="sub-heading">
        Allocated List (Total: 0)
      </h2>
      <!-- <app-data-table
        [tableHeaders]="tableAllAllocation__headersWithoutCheckbox"
        [tableEntries]="allocatedList"
        [pageSize]="50"
      ></app-data-table> -->

      <h2 class="sub-heading">
        Not Allocated List (Total: 0)
      </h2>
      <!-- <app-data-table
        [tableHeaders]="tableAllAllocation__headersWithoutCheckbox"
        [tableEntries]="notAllocatedList"
        [pageSize]="50"
      ></app-data-table> -->
    </div>
  </section>
</div>
